<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroConfigNiveis />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>
<script>
import CadastroConfigNiveis from "../Components/Cadastros/CadastroConfigNiveis.vue";

export default {
  name: "RegisterPromoter",
  components: {
    CadastroConfigNiveis,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
